<template>
<div class="EquipmentWarehousing">
  <el-drawer :title="drawerTitle" size="600px" :modal="true" :visible.sync="drawerShow" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="drawer">
    <equip-drawer :editData="selectData" :handleType="handleType" v-if="drawerShow" :loading.sync="loading" @confirm="handleConfirm" @cancel="handleCancel"></equip-drawer>
  </el-drawer>
  <el-drawer title="设备详情" size="600px" :modal="true" :visible.sync="datailsShow" :wrapperClosable="false" direction="rtl" ref="drawer">
    <device-details-drawer v-if="datailsShow" :datailsData="details" :urlData="urlData"></device-details-drawer>
  </el-drawer>
  <el-drawer title="安装设备" size="600px" :modal="true" :visible.sync="install.show" :wrapperClosable="false" direction="rtl" ref="drawer">
    <install-drawer v-if="install.show" :install="install" @installConfirm="installConfirm" @installCancel="installCancel"></install-drawer>
  </el-drawer>
  <!-- InstallRecord -->
  <el-drawer title="安装记录" size="1000px" :modal="true" :visible.sync="installRecordPar.show" :wrapperClosable="false" direction="rtl" ref="drawer">
    <install-record v-if="installRecordPar.show" :installRecordPar="installRecordPar" @installRecordConfirm="installRecordConfirm"></install-record>
  </el-drawer>

  <div class="cardLists">
    <div class="card" v-for="(card,index) in cardLists" :key="index">
      <div class="cardContent" :style="{backgroundImage: card.bgColor}">
        <div class="header ellipse clearfix">
          <img :src="card.img ? require('../../assets/img/back/device/' + card.img + '.png')  : ''" alt="">
          <span :title="card.typeName">{{card.typeName}}</span>
        </div>
        <div class="card-number" >
          <img :src="card.img ? require('../../assets/img/back/device/' + card.img + '.png')  : ''" alt="">
          <p class="top">
            <span :title="card.enableCount">{{numberFormatter(card.enableCount)}}</span>
            <span>{{card.typeName=='类型分布'?'启用':card.typeName=='在线统计'?'在线':card.typeName=='安装统计'?'已安装':card.typeName=='注册入库'?'已注册':card.typeName=='扫码出库'?'已安装':card.typeName=='近三月报警统计'?'已处理':card.typeName=='近三月故障统计'?'已处理':''}}</span>
          </p>
          <p class="bottom">
            <span>{{numberFormatter(card.totalCount)}}</span>
            <span>总数</span>
          </p>
          <!-- <div class="countAll"><b>{{card.enableCount ? card.enableCount : 0}}</b><span>/</span><b>{{card.totalCount ? card.totalCount : 0}}</b></div> -->
          <!-- <div class="countName">
            <b>{{card.typeName=='设备类型分布'?'启用':card.typeName=='设备在线统计'?'在线':card.typeName=='设备安装统计'?'已安装':card.typeName=='设备注册统计'?'已注册':card.typeName=='设备在库统计'?'在库':card.typeName=='报警处理状态统计'?'已处理':card.typeName=='故障处理状态统计'?'已处理':''}}</b>
            <span>/</span><b>总数</b>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <div class="mainContent">
    <div class="treeAside">
      <div class="treeTop">
        <span class="treeTopTitle">区域</span>
      </div>
      <div class="treeBox">
        <el-tree
          lazy
          :load="loadData"
          :props="props"
          v-if="1"
          class="tree"
          ref="tree"
          :indent="6"
          node-key="value"
          highlight-current
          :expand-on-click-node="false"
          @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree>
        <!-- <el-tree v-if="1" class="tree" ref="tree" :indent=6 :data="treeData" how-checkbox node-key="value" default-expand-all highlight-current :expand-on-click-node="false" @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree> -->
      </div>
    </div>
    <div class="container" ref="box">
      <div class="query" ref="topBox">
        <el-input v-show="currentTreeId == -1" class="common common1" v-model="searchTel" placeholder="手机号" @keyup.enter.native="serachData"></el-input>
        <el-input class="common" v-model="searchText" autocomplete="off" placeholder="设备ID/设备名称/IMEI" @keyup.enter.native="serachData" width="100"></el-input>
        <el-select class="common" v-model="keyWords.isInstall" placeholder="是否安装" clearable @change="changeRadio2" @clear="clearRadio2">
          <el-option label="已安装" :value="true"></el-option>
          <el-option label="未安装" :value="false"></el-option>
        </el-select>
        <el-select class="common" v-model="keyWords.isRegist" placeholder="是否注册" clearable>
          <el-option label="已注册" :value="true"></el-option>
          <el-option label="未注册" :value="false"></el-option>
        </el-select>
        <el-select class="common" v-model="keyWords.isOnline" placeholder="是否在线" clearable>
          <el-option label="在线" :value="true"></el-option>
          <el-option label="离线" :value="false"></el-option>
        </el-select>
        <el-select class="common" v-model="keyWords.typeId" placeholder="设备类型" clearable>
          <el-option v-for="(item,i) in deviceTypeList" :key="i" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select class="common" v-model="keyWords.isAlarm" placeholder="是否报警" clearable>
          <el-option label="报警" :value="true"></el-option>
          <el-option label="未报警" :value="false"></el-option>
        </el-select>
        <!-- <el-select class="common" v-model="keyWords.isFault" placeholder="是否故障" clearable>
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select> -->
        <el-input class="common" v-model="address" autocomplete="off" placeholder="安装位置" width="100"></el-input>
        <el-input class="common" v-model="tel" autocomplete="off" placeholder="手机号" width="100"></el-input>
        <el-date-picker
          class="common"
          style="margin-right: 10px;"
          v-model="range"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期(同步时间)"
          end-placeholder="结束日期(同步时间)">
        </el-date-picker>
        <el-button
          class="common"
          v-if="rolePermit('device:query')"
          type="primary"
          size="medium"
          @click="serachData('search')"
          icon="el-icon-search">条件搜索</el-button>
        <!-- <button class="primaryBtn common" v-if="rolePermit('device:query')" @click="serachData">搜索</button> -->
        <el-upload
          ref="upload"
          class="upload-demo"
          action
          :limit="1"
          :show-file-list="false"
          :http-request="handleHttpRequest"
          :before-upload="handleBeforeUpload">
          <el-button
            class="common"
            type="primary"
            size="medium"
            v-if="rolePermit('device:query')"
            icon="el-icon-search">文件搜索</el-button>
        </el-upload>
        <el-button
          class="common"
          type="success"
          size="medium"
          v-if="rolePermit('device:query')"
          @click="exportData(currentTreeId)"
          icon="el-icon-download">设备导出</el-button>
        <el-button
          class="common"
          type="success"
          size="medium"
          v-if="rolePermit('device:query')"
          @click="addAllClick">批量安装</el-button>
        <el-button
          class="common"
          :type="!checkDatas.length ?'info':'primary'"
          size="medium"
          v-if="rolePermit('device:query')"
          @click="removeEveAll">批量拆卸</el-button>
        <el-button
          class="common"
          :type="!checkDatas.length ?'info':'primary'"
          size="medium"
          v-if="rolePermit('device:query')"
          @click="handleBatchSettings">批量设置通知人</el-button>
        <!-- <button
          v-show="currentTreeId != -1"
          :class="['primaryBtn','btnS',!checkDatas.length ?'active':'']"
          @click="handleBatchSettings">批量设置通知人</button> -->
        <!-- <button
          v-show="currentTreeId != -1"
          :class="['primaryBtn','btnS',!checkDatas.length ?'active':'']"
          @click="removeEveAll">批量拆卸</button> -->
      </div>
      <!-- <div class="radio"> -->
        <!-- <button class="primaryBtn" v-if="rolePermit('device:add')" @click="addClick('add')">单个入库</button> -->
        <!-- <button class="primaryBtn"  @click="addAllClick" v-if="rolePermit('device:excel')">批量入库</button> -->
        <!-- <button :class="['primaryBtn',' btnS',isInstall==true?'active':'']" v-if="rolePermit('device:del')" :disabled="nodisabled1" @click="delAll">批量删除</button> -->
        <!-- <button :class="['primaryBtn','btnS',isInstall==true||isRegist==true?'active':'']" :disabled="nodisabled2" @click="register">批量注册</button> -->
        <!-- <span class="noEquipment">未安装：</span>
        <el-radio v-model="isRegist" :label="true" @change="changeRadio1">已注册</el-radio>
        <el-radio v-model="isRegist" :label="false" @change="changeRadio3">未注册</el-radio>
        <span class="line">|</span>
        <el-radio v-model="isInstall" :label="true" @change="changeRadio2">已安装</el-radio> -->
        <!-- <button class="primaryBtn" @click="exportExcel">报表导出</button> -->
      <!-- </div> -->
      <div>
        <border-table :tableData="dataList" :tableHeights="tableHeight" :pageSizes="[10, 20, 50]" :pages="pagination" @selectionChange="handleSelectionChange" :loading="tableLoading" :current-page="pagination.page" @currentChange="handleRoleCurrentChange" @sizeChange="handleRoleSizeChange" isAll="all">
          <el-table-column type="selection" width="50" :selectable="({ isInstall }) => !!isInstall"></el-table-column>
          <el-table-column key="name" prop="name" label="设备名称" show-overflow-tooltip width="130">
            <template slot-scope="scope">
              <span>{{scope.row.name}}</span>
              <p v-if="scope.row.repairType==1">
                <el-tag effect="dark" size="mini" type="warning">维修中...</el-tag>
              </p>
            </template>
          </el-table-column>
          <!-- <el-table-column key="name" prop="name" label="设备名称" show-overflow-tooltip width="140"></el-table-column> -->
          <el-table-column key="deviceTypeName" prop="deviceTypeName" label="设备类型" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column key="registTo" prop="registTo" label="注册类型" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.registTo==1">联通</span>
              <span v-if="scope.row.registTo==0">祥云</span>
              <span v-if="scope.row.registTo==2">电信</span>
            </template>
          </el-table-column> -->
          <el-table-column key="imei" prop="imei" label="IMEI" width="145"></el-table-column>
          <!-- <el-table-column prop="protocol" label="通信类型">
            <template slot-scope="scope">
              <span>{{scope.row.protocol==0? 'MQTT' : scope.row.protocol==1? 'NB' : scope.row.protocol==2? 'HTTP' : scope.row.protocol==3? 'TCP' : '未知'}}</span>
            </template>
          </el-table-column> -->
          <el-table-column key="deviceVar" prop="deviceVar" label="设备标签" show-overflow-tooltip></el-table-column>
          <el-table-column v-if="currentTreeId == -1" key="orgName" prop="orgName" label="所属组织" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column key="orgName" prop="orgName" label="所属组织" show-overflow-tooltip></el-table-column> -->
          <!-- <el-table-column prop="createTime" label="入库时间" width="100">
            <template slot-scope="scope">
              <span>{{scope.row.createTime}}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="" label="在线状态">
            <template slot-scope="scope">
              <div :style="{color:scope.row.isOnline ? '#00b050' : '#ff0000'}">{{scope.row.isOnline==true ? '在线' : '离线'}}</div>
            </template>
          </el-table-column>
          <!-- 闫总让把所有设备列表安装和注册状态去掉，改成安装位置：2023-05-24 15:00:02 -->
          <!-- <el-table-column prop="" label="注册状态">
            <template slot-scope="scope">
              <div :style="{color:scope.row.isRegist ? '#00b050' : '#ff0000'}">{{scope.row.isRegist==true ? '已注册' : '未注册'}}</div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="" label="安装状态">
            <template slot-scope="scope">
              <div :style="{color:scope.row.isInstall ? '#00b050' : '#ff0000'}">{{scope.row.isInstall==true ? '已安装' : '未安装'}}</div>
            </template>
          </el-table-column> -->
          <el-table-column prop="installLocationGPS" label="设备定位" show-overflow-tooltip />
          <el-table-column prop="installLocation" label="安装位置" show-overflow-tooltip />
          <!-- <el-table-column prop="" label="是否启用">
            <template slot-scope="scope">
              <div :style="{color:scope.row.isEnabled ? '#00b050' : '#ff0000'}">{{scope.row.isEnabled==true ? '是' : '否'}}</div>
            </template>
          </el-table-column> -->
          <el-table-column prop="" label="报警状态">
            <template slot-scope="scope">
              <div :style="{color:!scope.row.isAlarm ? '#00b050' : '#ff0000'}">{{scope.row.isAlarm==true ? '已报警' : '未报警'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="是否故障">
            <template slot-scope="scope">
              <div :style="{color:!scope.row.isFault ? '#00b050' : '#ff0000'}">{{scope.row.isFault==true ? '是' : '否'}}</div>
            </template>
          </el-table-column><!-- v-if="isInstall == true"  -->
          <el-table-column key="installTime" prop="installTime" label="安装时间" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column prop="registTime" label="注册时间" v-if="isRegist ==true" width="160">
            <template slot-scope="scope">
              <span>{{scope.row.registTime}}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="syncTime" label="最后一次同步时间" width="200" align="center">
          </el-table-column>
           <!-- fixed="right"  v-if="!isInstall"-->
          <el-table-column prop="" label="操作" width="280" fixed="right">
            <template slot-scope="scope">
              <el-button v-if="!scope.row.isInstall&&rolePermit('device:install')" type="text" icon="el-icon-sell" @click="installEve(scope.row)">安装</el-button>
              <el-button :style="{color:scope.row.isInstallByMyself?'#dd3071':'#ccc'}" :disabled="!scope.row.isInstallByMyself" v-else type="text" icon="el-icon-sold-out" @click="removeEve(scope.row)">拆卸</el-button>
              <!-- <el-button v-if="!scope.row.isEnabled" type="text" icon="el-icon-unlock" @click="enableEve(scope.row)">启用</el-button> -->
              <!-- <el-button style="color:#dd3071" v-else type="text" icon="el-icon-lock" @click="disableEve(scope.row)">禁用</el-button> -->
              <!-- <el-button v-if="!scope.row.isRegist&&rolePermit('device:regist')" type="text" icon="el-icon-download" @click="registerEve(scope.row)">注册</el-button> -->
              <!-- <el-button style="color:#dd3071" v-else type="text" icon="el-icon-upload2" @click="CancelEve(scope.row)">解除注册</el-button> -->
              <!-- <el-button type="text" icon="el-icon-edit-outline" @click="editClick(scope.row)" v-if="radio1 != '1'&&rolePermit('device:edit')">编辑</el-button> -->
              <!-- <el-button style="color:#dd3071" type="text" icon="el-icon-delete" @click="delClick(scope.row)" v-if="radio1 != '1'&&rolePermit('device:del')">删除</el-button> -->
              <el-button v-if="rolePermit('device:query')" type="text" icon="el-icon-delete" :disabled="scope.row.isInstall" @click="detailClose(scope.row)">删除</el-button>
              <el-button v-if="rolePermit('device:query')" icon="el-icon-document" type="text" @click="detailClick(scope.row)">详情</el-button>
              <el-dropdown style="margin-left: 10px;">
                <el-button type="text">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <el-button v-if="rolePermit('device:query') && scope.row.repairType != 1" type="text" @click="repairClick(scope.row)">
                      <i class="set-repair"></i>
                      <span class="btn-repair">报修</span>
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <!-- icon="el-icon-collection-tag"  -->
                    <el-button v-if="rolePermit('device:query')" type="text" @click="labelClick(scope.row)">标签</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <!-- icon="el-icon-reading" -->
                    <el-button v-if="rolePermit('device:query')" type="text" @click="installRecord(scope.row)">安装记录</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <!-- icon="el-icon-collection-tag"  -->
                    <el-button v-if="rolePermit('device:query')" type="text" @click="handleAlarmPush(scope.row)">设置通知人</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <!-- icon="el-icon-collection-tag"  -->
                    <el-button v-if="rolePermit('device:query')" type="text" @click="handleSetPlace(scope.row)">设置场所</el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </border-table>
      </div>
    </div>
  </div>
  <el-dialog
    title="编辑标签"
    :visible.sync="isLabel"
    width="30%">
      <span>标签：</span>
      <el-select v-model="deviceTag" placeholder="请选择">
        <el-option
          v-for="(item, index) in OriginOptions"
          :key="index"
          :label="item.value"
          :value="item.key">
        </el-option>
      </el-select>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isLabel = false">取 消</el-button>
      <el-button type="primary" @click="handleSureLabel">确 定</el-button>
    </span>
  </el-dialog>
  <!-- 设置通知人窗口 -->
  <el-dialog
    :title="addUserPeople"
    :visible.sync="alarmPush"
    @closed="handleClosed"
    width="500px">
    <div class="add-user-tell-box">
      <span class="title">报警和故障通知人员类型：</span>
      <el-select v-model="pushUser.noticeUserType" placeholder="请选择">
        <el-option
          v-for="(item, index) in noticeUserType"
          :key="index"
          :label="item.value"
          :value="item.key">
        </el-option>
      </el-select>
    </div>
    <div class="add-user-tell-box" v-show="(pushUser.noticeUserType == 4 || pushUser.noticeUserType == 5) && bindType == 'single'">
      <span class="title">使用人姓名：</span>
      <el-input v-model="pushUser.bindUserName" maxlength="30" placeholder="请输入使用人姓名"></el-input>
    </div>
    <div class="add-user-tell-box" v-show="(pushUser.noticeUserType == '4' || pushUser.noticeUserType == '5') && bindType == 'single'">
      <span class="title">使用人电话：</span>
      <div class="tel-box">
        <div class="tell" v-for="(item, i) in pushUser.bindUserTel" :key="`${i}${item}`">
          <el-input v-model="bindUserTel[i]" placeholder="请输入使用人电话" @input.native="handleTell($event,i)" v-only-number></el-input>
          <i v-show="i == pushUser.bindUserTel.length-1" @click="handleAddTell(i)" class="icons el-icon-circle-plus-outline"></i>
          <i v-show="i != 0" @click="handleDeleteTell(i)" class="icons el-icon-delete"></i>
        </div>
      </div>
    </div>
    <!-- <div style="margin-bottom: 20px;" class="bangding" v-if="addUserPeople != '批量设置使用人'">
      <span>设备绑定使用人：</span>
      <el-input v-model="pushUser.bindUserTel" oninput="value = value.replace(/\s/g, '')" placeholder="请输入使用人"></el-input>
      <div class="telTitle">注：请添加至多三个手机号且用英文符号‘;’或‘,’隔开。</div>
    </div> -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="alarmPush = false">取 消</el-button>
      <el-button type="primary" @click="handleSubPushUser">确 定</el-button>
    </div>
  </el-dialog>
  <!-- 报修窗口 -->
  <el-drawer title="报修" size="500px" :modal="true" :visible.sync="repairDrawer.show" @close="handleDrawerClose" :wrapperClosable="false" direction="rtl" ref="drawer">
    <div class="drawerWrap">
      <div class="drawerBody">
        <el-form class="formBox" ref="repairDrawerForm" :model="repairDrawer.form" :rules="repairDrawer.formRules" label-position="right" label-width="120px">
          <!-- <el-form-item label="设备ID" prop="deviceId">
            <el-input v-model.trim="repairDrawer.form.deviceId" type="text" :maxlength="30" placeholder="请输入设备ID" disabled></el-input>
          </el-form-item> -->
          <el-form-item label="设备IMEI" prop="imei">
            <el-input v-model.trim="repairDrawer.form.imei" type="text" :maxlength="30" placeholder="请输入设备IMEI" disabled></el-input>
          </el-form-item>
          <el-form-item label="报修信息" prop="repairDesc">
            <el-input v-model.trim="repairDrawer.form.repairDesc" type="textarea" :maxlength="50" :rows="3" placeholder="请输入报修信息"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawerFoot">
        <el-button type="primary" @click="handleAddSave" :loading="repairDrawer.saving">{{ repairDrawer.saving ? '提交中' : '提交' }}</el-button>
        <el-button @click="repairDrawer.show = false">取 消</el-button>
      </div>
    </div>
  </el-drawer>
  <!-- 设置消防场所 -->
  <el-drawer title="消防场所" size="500px" :visible.sync="placeShow" direction="rtl" ref="drawer">
    <div class="drawerWrap">
      <div class="drawerBody">
        <el-table v-loading="moreLoading" :data="placeList" @current-change="handleSingleSelect">
          <el-table-column  width="55" align="center" >
            <template slot-scope="scope">
              <el-radio v-model="placeSelected" :label="scope.row.id">{{''}}</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="场所名称" prop="placeName" />
          <el-table-column label="一级标签" prop="firstTag" />
          <el-table-column label="二级标签" prop="secondTag" />
          <el-table-column label="三级标签" prop="thirdTag" />
        </el-table>
        <div style="height: 40px;margin-top: 10px;">
          <el-pagination style="float: right;" background layout="prev, pager, next" :total="placeTotal" />
        </div>
      </div>
      <div class="drawerFoot">
        <el-button type="primary" @click="handlePlaceSave" :loading="placeLoading">{{ placeLoading ? '提交中' : '提交' }}</el-button>
        <el-button @click="placeShow = false">取 消</el-button>
      </div>
    </div>
  </el-drawer>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTableDevice";
import EquipDrawer from "@/components/deviceManagement/EquipDrawer";
import DeviceDetailsDrawer from "@/components/deviceManagement/DeviceDetailsDrawer";
import InstallDrawer from "@/components/deviceManagement/InstallDrawer";
import InstallRecord from "@/components/deviceManagement/InstallRecord";
import { debounce } from '@/utils/validate'
export default {
  components: {
    BorderTable,
    EquipDrawer,
    DeviceDetailsDrawer,
    InstallDrawer,
    InstallRecord
  },
  directives: {
    'only-number': {
      bind: function(el) {
        el.addEventListener('input', function(e) {
          e.target.value = e.target.value.replace(/\D/g, '');
        });
      }
    }
  },
  data() {
    return {
      file: null,
      imeis: '',
      range: [],
      urlData: [],
      OriginOptions: [],
      keyWords: {
        isAlarm: "",
        isFault: "",
        isInstall: true,
        isOnline: "",
        isRegist: "",
        typeId: ''
      },
      deviceTypeList: [],
      cardLists: [
        {
          typeName: '类型分布',
          bgColor: 'linear-gradient(to right, #E16FEB, #8F65F8)',
          img: 'type',
          enableCount: '',
          totalCount: '',
          once: true,
        },
        {
          typeName: '在线统计',
          bgColor: 'linear-gradient(to right, #41D79C, #50BD2E)',
          img: 'online',
          enableCount: '',
          totalCount: '',
          once: false,
        },
        {
          typeName: '安装统计',
          bgColor: 'linear-gradient(to right, #60ACFF, #6A88FE)',
          img: 'install',
          enableCount: '',
          totalCount: '',
          once: false,
        },
        {
          typeName: '注册入库',
          bgColor: 'linear-gradient(to right, #35C9C1, #15A2D0)',
          img: 'register',
          enableCount: '',
          totalCount: '',
          once: true,
        },
        {
          typeName: '扫码出库',
          bgColor: 'linear-gradient(to right, #8171DC, #006FE0)',
          img: 'inbox',
          enableCount: '',
          totalCount: '',
          once: true,
        },
        {
          typeName: '近三月报警统计',
          bgColor: 'linear-gradient(to right, #FF8266, #FE6F97)',
          img: 'alarm',
          enableCount: '',
          totalCount: '',
          once: false,
        },
        {
          typeName: '近三月故障统计',
          bgColor: 'linear-gradient(to right, #FCB25B, #F87D40)',
          img: 'default',
          enableCount: '',
          totalCount: '',
          once: false,
        }
      ],
      treeData: [],
      radio1: "0",
      names: "",
      styleObject: {
        height: ""
      },
      isLabel: false,
      tableLoading: false,
      tableHeight: 'auto',
      dataList: [],
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      drawerShow: false,
      drawerTitle: "",
      handleType: "",
      // orgId: this.storage.getSession("orgId"),
      searchText: "",
      searchTel: "",
      address: '',
      tel: '',
      ids: [],
      arry: [],
      checkDatas: [],
      selectData: {},
      nodisabled1: false,
      nodisabled2: true,
      currentTreeId: null,
      isInstall: false,
      isRegist: true,
      details: {},
      datailsShow: false,
      install: {
        show: false,
        dataList: {},
        id: "",
      },
      installRecordPar: {
        show: false,
        dataList: {},
        id: "",
      },
      typeOptions: [],
      props: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      },
      deviceTag: '',
      deviceId: '',
      repairDrawer: {
        show: false,
        form: {
          deviceId: '',
          imei: '',
          repairDesc: ''
        },
        formRules: {
          deviceId: [{ required: true, message: "设备ID不能为空", trigger: "blur" }],
          imei: [{ required: true, message: "设备IMEI不能为空", trigger: "blur" }],
          repairDesc: [{ required: true, message: "报修信息不能为空", trigger: "blur" }],
        },
        saving: false,
        rowTitle: ''
      },
      // 设置使用人窗口
      alarmPush: false,
      bindType: 'all',
      pushUser: {
        deviceId: '',
        noticeUserType: '',
        bindUserName: '',
        bindUserTel: [''],
      },
      addUserPeople: '',
      BatchIds: '',
      noticeUserType: [
        { value: '通知安装人', key: '1' },
        { value: '通知负责人', key: '2' },
        { value: '通知使用人', key: '4' },
        { value: '通知安装和负责人', key: '3' },
        { value: '通知负责人和使用人', key: '5' },
      ],
      bindUserTel: ['', '', ''],
      placeList: [],
      placeShow: false,
      moreLoading: false,
      placeLoading: false,
      placeTotal: 0,
      placeData: {
        imei: '',
        deviceId: '',
        inRelation: '',
        placeTypeTenantId: ''
      },
      placeSelected: ''
    }
  },
  created() {
    this.makeheight()
    window.onresize = debounce(this.makeheight)
    // this.queryTreeNode()
    // this.initData();
    // this.getStatistics()
    this.getDeviceType()
    this.getDeviceTypeAll()
    this.getDataOrgin()

    this.placeList = []
    this.getFirePlaceList()
    
  },
  watch:{
    // screenSize(){
    //   this.makeheight();
    // }
  },
  computed:{
    numberFormatter () {
      return number => {
        if (!number) return 0

        const numbers = number.toString().split('').reverse()
        const segs = []

        while (numbers.length) segs.push(numbers.splice(0, 3).join(''))

        return segs.join(',').split('').reverse().join('')
      }
    }
  },
  methods: {
    handleSetPlace ({ imei, id }) {
      this.placeData.imei = imei
      this.placeData.deviceId = id
      this.placeShow = true
      this.getPlaceId(imei)
      // placeData: {
      //   imei: '',
      //   deviceId: '',
      //   inRelation: '',
      //   placeTypeTenantId: ''
      // },
    },
    async getFirePlaceList () {
      this.moreLoading = true
      let { code, data: { data, totalCount }, msg } = await this.request.post("/front/system/placeTypeTenant/query", {
        placeName: '',
        pageSize: 15,
        page: this.changePage
      })
      this.moreLoading = false
      if (code != 200) return 
      this.placeList = data
      this.placeTotal = Math.ceil(totalCount/15)
    },
    async handlePlaceSave () {
      let { code, msg } = await this.request.post("/front/device/placeType/save", { ...this.placeData })
      if (code != 200) return this.$message({ type: 'error', message: msg })

      this.placeShow = false
      this.initData()
      this.$message({ type: 'success', message: '操作成功' })
    },
    handleSingleSelect(selection) {
      this.placeSelected = selection.id
      this.placeData.inRelation = selection.thirdVar
      this.placeData.placeTypeTenantId = selection.id

    },
    getPlaceId(imei) {
      this.request.get(`/front/device/placeType/${imei}`).then(res => {
        if (res.code != 200) return
        this.placeSelected = res.data ? (res.data.id || '') : ''
      })
    },
    // 点击批量设置
    handleBatchSettings () {
      this.bindType = 'all'
      this.addUserPeople = '批量设置通知人'
      const len = this.checkDatas.length
      if (!len) {
        this.$message({ type: 'warning', message: '请先勾选需要设置的设备！' })
      } else {
        let idsTemp = this.checkDatas.reduce((total, { id }) => {
          return total += `${id},`
        }, '')
        let ids = idsTemp.substr(0, idsTemp.length - 1)
        this.BatchIds = ids
        this.alarmPush = true
      }
    },
    // 添加使用人设置
    async handleAlarmPush ({ id }) {
      this.bindType = 'single'
      this.addUserPeople = '设置通知人'

      this.alarmPush = true
      this.pushUser.deviceId = id
      let { code, data, msg} = await this.request.get("/front/device/" + id)

      if (code != 200) return this.msg.warn(res.msg)

      let { noticeUserType,  userTel, userName } = data

      userTel && (userTel.split(';').forEach((item, i) => {
        this.bindUserTel[i] = item
      }))

      this.pushUser.bindUserName = userName
      this.pushUser.noticeUserType = noticeUserType
      this.pushUser.bindUserTel = userTel && userTel.split(';') || ['']
    },
    // 弹窗关闭
    handleClosed () {
      this.alarmPush = false
      // this.addUserPeople = '添加使用人'
      this.pushUser = {
        deviceId: '',
        noticeUserType: '',
        bindUserName: '',
        bindUserTel: ['']
      }
      this.bindUserTel = ['', '', '']
    },
    handleTell (e, i) {
      // this.bindUserTel[i] = e.target.value.replace(/\D/g, '')
      console.log(e.target.value, i)
    },
    handleAddTell (i) {
      if (i >= 2) {
        return this.msg.warn("最多可填写3个电话！")
      }
      if (this.bindUserTel[i] == '') {
        return this.msg.warn("电话不能为空哦！")
      }

      this.pushUser.bindUserTel.push('')
    },
    handleDeleteTell (index) {
      this.bindUserTel.splice(index, 1)
      this.pushUser.bindUserTel.splice(index, 1)
    },
    // 提交通知人设置
    async handleSubPushUser () {
      let { noticeUserType, deviceId, bindUserName } = this.pushUser
      
      let params = { noticeUserType, deviceId }

      if (this.bindType == 'all') {
        let params = { id: this.BatchIds, noticeUserType }
        let { code, msg } = await this.request.post('/front/device/setNoticeType', params)
        if (code != 200) return this.msg.error(msg)

        this.msg.success('批量设置成功')
        this.alarmPush = false
      } else {
        if (noticeUserType == 4 || noticeUserType == 5) {

          let tel = this.bindUserTel.filter(item => item).join(';')

          if (!bindUserName || !tel) {
            return this.msg.warn("请填写使用人姓名/电话！")
          }

          let flag = false
          tel.split(';').forEach(item => {
            let test = /^1(3|4|5|6|7|8|9)\d{9}$/.test(item)
            if (item.length != 11) {
              flag = true
              return this.$message({ type: 'warning', message: '电话位数为11位！' })
            } else if (!test) {
              flag = true
              return this.$message({ type: 'warning', message: '电话格式不正确！' })
            }
          })

          if (flag) return

          params.bindUserName = bindUserName
          params.bindUserTel = tel
        }

        let { code, msg } = await this.request.post('/front/device/bindDeviceUser', params)

        if (code != 200) return this.msg.error(msg)

        this.msg.success('设置成功')
        this.alarmPush = false
      }

      // if (this.addUserPeople == '添加使用人') {
      //   if (!this.pushUser.bindUserTel && (this.pushUser.noticeUserType == 4 || this.pushUser.noticeUserType == 5)) {
      //     this.msg.warn("请填写使用人电话！")
      //     let newValue = this.pushUser.bindUserTel.trim().replace(/[^[\u4E00-\u9FA5a-zA-Z\-\-_—.'\"!?。，；！？‘’“” ]/g, "");
      //     if (this.pushUser.bindUserTel && this.pushUser.bindUserTel.length < 11) {
      //       this.msg.warn("请填写正确的电话！")
      //       return
      //     } else if (this.pushUser.bindUserTel.length > 35) {
      //       this.msg.warn("只能添加三个手机号且用英文符号‘;’或‘,’隔开，请检查！")
      //       return
      //     } else if (newValue) {
      //       this.msg.warn("请使用英文符号‘;’或‘,’")
      //       return
      //     }
      //     return
      //   }
      //   let par = {...this.pushUser}
      //   this.request.post('/front/device/bindDeviceUser', par).then(res => {
      //     if (res.code == 200) {
      //       this.alarmPush = false
      //       this.msg.success('设置成功')
      //       this.pushUser = {
      //         noticeUserType: '',
      //         bindUserTel: '',
      //         deviceId: '',
      //       }
      //     } else {
      //       this.msg.error(res.msg)
      //     }
      //   })
      // } else {
      //   let par = {
      //     id: this.BatchIds,
      //     noticeUserType: this.pushUser.noticeUserType,
      //   }
      //   this.request.post('/front/device/setNoticeType', par).then(res => {
      //     if (res.code == 200) {
      //       this.alarmPush = false
      //       this.msg.success('设置成功')
      //     } else {
      //       this.msg.error(res.msg)
      //     }
      //   })
      // }
    },
    getDataOrgin () {
      this.request.get('/front/system/urltag/typeDevlist').then(res => {
        if (res.code == 200) {
          this.OriginOptions = res.data
        }
      })
    },
    handleSureLabel (row) {
      this.request.get('/front/system/urltag/adddevicetag', {
        id: this.deviceId,
        tagKey: this.deviceTag
      }).then(res => {
        if (res.code == 200) {
          this.isLabel = false
          this.initData()
          this.msg.success('标签编辑成功')
        } else {
          this.msg.warn('标签编辑失败,请重新编辑！')
        }
      })
    },
    async getDeviceTypeAll() {
      const { code, data, msg } = await this.request.get("/front/device/class/all")
      if (code !== 200) return

      this.typeOptions = data
    },
    showLabel(label) {
      if (!label) return label

      return label
    },
    // // 查询组织
    // queryTreeNode(pid = 0) {
    //   this.request.get(`/front/system/organization/findTreeById?id=${pid}`)
    //     .then(rs => {
    //       // console.log(rs);

    //       this.treeData = rs.code === 200 ? rs.data : [];
    //       this.currentTreeId = this.treeData.length > 0 ? (this.treeData[0].value?this.treeData[0].value:this.storage.getSession("orgId")) :this.storage.getSession("orgId");
    //     })
    //     .catch(error => (this.treeData = []));
    // },
    // 查询区域
    queryTreeNode(pid = 0) {
      this.request.get(`/front/device/region/findTreeById?id=${pid}`).then(rs => {
        this.treeData = rs.code === 200 ? rs.data : [];
        this.currentTreeId = this.treeData.length > 0 ? (this.treeData[0].value?this.treeData[0].value:0):0;
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.treeData[0].value)
        })
        this.initData()
      }).catch(error => (this.treeData = []));
    },
    // 查询区域
    loadData (node, resolve) {
      if (node.level === 0) {
        let root = { id: 0, label: '区域机构', parentId: 0, value: 0 }
        this.initData('once')

        
        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(0)
          let nodedata = node.childNodes[0]
          nodedata.expanded = true
          nodedata.loadData()
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/device/region/findTreefenjiById?id=${pid}`).then(rs => {
          let data = rs.code === 200 ? rs.data : []

          // 区域-终端出库设备
          if (node.level == 1) {
            data.unshift({ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true })
          }

          // this.initData()
          resolve(data)
        }).catch(error => {
          console.error(error)
          let temp = node.level == 1 ? [{ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true }] : []
          resolve(temp)
        })        
      }
    },    
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.currentTreeId = item ? (item.value ? item.value :0) : 0;
      this.pagination.currentPage = 1;
      this.initData();
      // this.getStatistics()
    },
    async initData(type) {
      this.selectData = {}
      this.tableLoading = true;
      // console.log(`this.keyWords.typeId`, this.keyWords.typeId)
      let params = {
        isInstall: this.keyWords.isInstall,
        isAlarm: this.keyWords.isAlarm,
        isFault: this.keyWords.isFault,
        isRegist: this.keyWords.isRegist,
        isOnline: this.keyWords.isOnline,
        key: this.searchText,
        address: this.address,
        tel: this.tel,
        orgId: this.currentTreeId ? this.currentTreeId : 0,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        typeId: this.keyWords.typeId,
        // startTime: '',
        // endTime: '',
        sort: 'createTime',
        order: 'desc',
        imeis: this.imeis
      }

      if (this.range && this.range.length) {
        params.startTime = this.range[0]
        params.endTime = this.range[1]
      }

      let url = '/front/device/query'
      if (params.orgId == -1) {
        params.tel = this.searchTel
        url = '/front/device/queryOutbound'
      }
      // let url = params.orgId == -1 ? '/front/device/queryOutbound' : "/front/device/query"
      let res = await this.request.post(url, params)
      this.tableLoading = false;

      if (res.code == 200) {
        this.dataList = res.data.data;
        this.pagination.total = res.data.totalCount;
      } else if (res.code == 500) {
        this.msg.warn(res.msg);
      }

      if (type == 'search') return
      if (type == 'once') this.getStatisticsOnce()

      this.getStatistics()
    },
    async getDeviceType() {
      const { data, code, msg } = await this.request.post('/front/device/type/query', {
        page: 1,
        pageSize: 1000
      })
      if (code !== 200) {
        if(code==500){
          return this.$message.error(msg)
        }
        return
      }
      this.deviceTypeList = data.data
      // console.log(`data`, data)
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    // makeheight(height = 210) {
    //   let _this = this;
    //   _this.styleObject.height = window.innerHeight - height + "px";
    //   window.onresize = () => {
    //     return (() => {
    //       _this.styleObject.height = window.innerHeight - height + "px";
    //     })();
    //   };
    // },
    // 动态获取中间滚动高度,'height'为头部和尾部的高度之和makeheightCons
    makeheight () {
      this.$nextTick(() => {
        let boxHeight = this.$refs.box.offsetHeight
        let topHeight = this.$refs.topBox.offsetHeight
        this.tableHeight = `${boxHeight - topHeight - 50}px`
        // console.log(1123, this.tableHeight)
      })
    },
    editClick(row) { //编辑
      this.drawerShow = true
      this.drawerTitle = "编辑设备"
      this.handleType = "edit"
      this.selectData = row
      // this.$store.commit("saveCurrDbSource", "编辑设备");
    },
    delClick(row) {
      //删除
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          this.request.delete("/front/device/del?ids=" + row.id).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              this.$message({ type: "success", message: "删除成功!" })
              let num = ''
              if (this.pagination.total > 1) {
                num = (this.pagination.total - 1) % this.pagination.pageSize
                if (num == 0) {
                  if (this.pagination.currentPage > 1) {
                    this.pagination.currentPage = this.pagination.currentPage - 1
                  }
                }
              }
              this.initData()
            } else if (res.code == 500) {
              this.msg.warn(res.msg)
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    labelClick (row) { // 编辑标签
      this.isLabel = true
      this.deviceId = row.id
      this.deviceTag = row.deviceTag
    },
    detailClick(row) { //详情
      this.request.get("/front/device/" + row.id).then((res) => {
        if (res.code == 200) {
          this.details = res.data
          this.datailsShow = true
          let typeId = this.details.deviceType;
          this.details.deviceType = this.typeOptions.find((e) => e.id === typeId).name
        } else if (res.code == 500) {
          this.msg.warn(res.msg);
        }
      });
    },
    installCancel() {
      this.install.show = false
    },
    addClick(type) {
      // console.log(this.radio1);
      //新增单个
      // this.backInit()
      this.drawerShow = true;
      this.drawerTitle = "单个入库";
      this.handleType = "add";
      // this.$store.commit("saveCurrDbSource", "单个入库");
    },
    addAllClick(type) {
      //新增批量
      // this.backInit()
      this.drawerShow = true;
      this.drawerTitle = "批量安装";
      this.handleType = "addAll";
      // this.$store.commit("saveCurrDbSource", "单个入库");
    },
    // 导入文件
    async handleHttpRequest () {
      let formData = new FormData()
      formData.append('file', this.file)
      let { code, data, msg } = await this.request.post('/front/device/queryBatchImei', formData)
      if (code == 200) {
        this.imeis = data || ''
        this.pagination.currentPage = 1;
        this.keyWords = { isInstall: '', isAlarm: '', isFault: '', isRegist: '', isOnline: '', typeId: '' }
        this.tel = ''
        this.address = ''
        this.searchText = ''
        this.range = []

        this.initData()
        this.$refs.upload.clearFiles()
        return this.$message({ type: 'success', message: `导入成功，查询数据如下` })
      } else {
        return this.$message({ type: 'warning', message: `导入失败：${msg}` })
      }
    },
    handleBeforeUpload (file) {
      this.file = file
      var FileExt = file.name.replace(/.+\./, '')
      if (['xlsx', 'xls'].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({ type: 'warning', message: '请导入xlsx或xls格式的文件！' })
        return false
      }
    },
    serachData(type) {
      //查询//搜索
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "");
      this.imeis = ''
      this.pagination.currentPage = 1;
      this.initData(type);
    },
    /**
     * @Description 设备导出
     * @Author      YOYO     -             2022-02-14
     */
    exportData (type) {
      let { isInstall, isAlarm, isFault, isRegist, isOnline, typeId } = this.keyWords
      let { pagination: { currentPage, pageSize }, searchText, currentTreeId } = this
      let params = {
        isInstall,
        isAlarm,
        isFault,
        isRegist,
        isOnline,
        key: searchText,
        orgId: currentTreeId ? currentTreeId : 0,
        page: currentPage,
        pageSize,
        typeId,
        sort: "createTime",
        order: 'desc',
      }
      let paramsString = ''
      for (let [key, val] of Object.entries(params)) {
        paramsString += `${key}=${val}&`
      }
      this.$confirm('此操作将导出报表, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(type)
        if (type == -1) {
          window.open(`${this.baseUrlAddr}/front/device/queryOutboundExcelExport?${paramsString}`)
        } else {
          window.open(`${this.baseUrlAddr}/front/device/download?${paramsString}`)
        }
        this.msg.success('导出成功')
        return
      }).catch(() => {
        this.msg.info('已取消导出')
      })
    },
    nowtime() {
      // 将当前时间转换成yyyy-mm-dd格式
      var date = new Date()
      var seperator1 = '-'

      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate =
        date.getFullYear() + seperator1 + month + seperator1 + strDate

      return currentdate
    },
    //关闭抽屉
    closeMess() {
      this.loading = false;
    },
    handleConfirm(data) {
      //确认 
      // console.log(data);
      if (data == 200) {
        this.drawerShow = false;
        this.pagination.currentPage = 1
        this.initData()
      }
    },
    handleCancel(data) {
      //取消
      // console.log(data);
      this.drawerShow = false;
    },
    //表格当前页变化时
    handleRoleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.initData();
    },
    //表格展示条数变化时
    handleRoleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.initData();
    },
    changeRadio1() {
      this.nodisabled1 = false
      this.nodisabled2 = true
      this.isInstall = false
      this.pagination.currentPage = 1;
      // this.searchText = ''
      //已注册
      this.initData();
    },
    clearRadio2(data){
      this.nodisabled1 = false
      this.nodisabled2 = true
      this.isInstall = false
      this.isRegist = ''
      this.pagination.currentPage = 1;
    },
    changeRadio2(data) {
      if(data){
        this.nodisabled1 = true        
        this.isInstall = true        
      }else{
        this.nodisabled1 = false        
        this.isInstall = false   
      }
      this.nodisabled2 = true
      this.isRegist = ''
      this.pagination.currentPage = 1;
      // this.searchText = ''
      //已安装
      // this.initData();
    },
    changeRadio3() {
      this.nodisabled1 = false
      this.nodisabled2 = false
      this.isInstall = false
      this.pagination.currentPage = 1;
      // this.searchText = ''
      //未注册
      this.initData();
    },
    delAll() {
      //批量删除
      if (this.checkDatas.length == 0) {
        this.msg.warn("请先勾选删除内容！")
      } else {
        let arr = []
        for (var i = 0; i < this.checkDatas.length; i++) {
          arr.push(this.checkDatas[i].id)
        }
        this.arry = arr
        // console.log(this.arry)
        let params = {
          ids: this.arry.toString()
        }
        this.$confirm('此操作将永久删除内容, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.request.delete("/front/device/del", params).then(res => {
            // console.log(res)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              let num = ''
              if (this.pagination.total > this.pagination.pageSize) {
                num = (this.pagination.total - this.checkDatas.length) % this.pagination.pageSize
                if (num == 0) {
                  if (this.pagination.currentPage > 1) {
                    this.pagination.currentPage = this.pagination.currentPage - 1
                  }
                }
              }
              this.initData()
            }
          })
        }).catch(() => {
          this.$message({ type: 'info', message: '已取消删除' })
        });
      }
    },
    register() {
      //批量注册
      if (this.checkDatas.length == 0) {
        this.msg.warn("请先勾选注册设备！")             
      } else {
        let arr = []
        for (var i = 0; i < this.checkDatas.length; i++) {
          arr.push(this.checkDatas[i].id)
        }
        this.arry = arr
        // console.log(this.arry)
        let params = {
          ids: this.arry.toString()
        }
        this.$confirm('此操作将注册设备, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.request.postParamsData("/front/device/regist", params).then(res => {
            // console.log(res)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '注册成功!'
              });
              this.initData()
            } else if (res.code == 500) {
              this.msg.warn(res.data[0].msg);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消注册'
          });
        });
      }
    },
    regClick(row) {
      this.$confirm('此操作将注册该设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.request.post("/front/device/regist?ids=" + row.id).then(res => {
          // console.log(res)
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '注册成功!'
            });
            let num = ''

            if (this.pagination.total > 1) {
              num = (this.pagination.total - 1) % this.pagination.pageSize
              if (num == 0) {
                this.pagination.currentPage = this.pagination.currentPage - 1
              }
            }
            this.initData()
          } else if (res.code == 500) {
            this.msg.warn(res.msg);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消注册'
        });
      });
    },
    handleSelectionChange(data) { //多选
      // console.log(data)
      this.checkDatas = data
    },
    //报表导出
    exportExcel() {
      this.$confirm(
        "没有进行条件筛选将导出全部数据，如果数据量过大请耐心等待，是否继续?",
        "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        window.open(this.baseUrlAddr + '/front/device/download?typeId=' + this.keyWords.typeId + '&registTo=' + this.keyWords.isRegist + '&orgId=' + this.currentTreeId + '&isEnabled=' + this.keyWords.isEnabled+ '&isOnline=' + this.keyWords.isOnline)
      });
    },
    getStatistics() {
      // 置空数据
      let cardlist = this.cardLists.map(item => {
        if (!item.once) {
          item.enableCount = '...'
          item.totalCount = '...'
        }
        return item
      })
      this.cardLists = cardlist

      let orgId = this.currentTreeId ?? ''

      this.request.post(`/front/device/onlineStatistics?orgId=${orgId}`).then(res => { //设备在线统计
        let { code, data, msg } = res
        if (code == 200) {
          let index = this.cardLists.findIndex(({ typeName }) => typeName == "在线统计")
          
          let enableCount = 0
          let totalCount = 0
          data.forEach(item => {
            enableCount += item.onlineCount
            totalCount += item.totalCount
          });

          this.cardLists[index].enableCount = enableCount
          this.cardLists[index].totalCount = totalCount
        } else if (code == 500) {
          this.msg.warn(msg);
        }
      })
      this.request.post(`/front/device/installStatistics?orgId=${orgId}`).then(res => { //设备安装统计
        let { code, data, msg } = res
        if (code == 200) {
          let index = this.cardLists.findIndex(({ typeName }) => typeName == "安装统计")

          let enableCount = 0
          let totalCount = 0
          data.forEach(item => {
            enableCount += item.installedCount
            totalCount += item.totalCount
          });

          this.cardLists[index].enableCount = enableCount
          this.cardLists[index].totalCount = totalCount
        } else if (code == 500) {
          this.msg.warn(msg);
        }
      }).catch(error => {
        // console.log(error)
      })
      
      this.request.post(`/front/alarm/record/getAlarmRecordHandleStatistics1?orgId=${orgId}`).then(res => { //报警处理状态统计
        // console.log(res)
        let { code, data, msg } = res
        if (code == 200) {
          let index = this.cardLists.findIndex(({ typeName }) => typeName == "近三月报警统计")

          let enableCount = 0
          let totalCount = 0
          data.forEach(item => {
            enableCount += item.handled
            totalCount += item.unHandle + item.handled
          });

          this.cardLists[index].enableCount = enableCount
          this.cardLists[index].totalCount = totalCount
        } else if (code == 500) {
          this.msg.warn(msg);
        }
      })
      this.request.post(`/front/fault/record/getFaultRecordHandleStatistics1?orgId=${orgId}`).then(res => {
        // console.log(res)
        let { code, data, msg } = res
        if (code == 200) {
          let index = this.cardLists.findIndex(({ typeName }) => typeName == "近三月故障统计")

          let enableCount = 0
          let totalCount = 0
          data.forEach(item => {
            enableCount += item.handled
            totalCount += item.unHandle + item.handled
          })

          this.cardLists[index].enableCount = enableCount
          this.cardLists[index].totalCount = totalCount
        } else if (code == 500) {
          this.msg.warn(msg);
        }
      })
    },
    getStatisticsOnce () {
      // 置空数据
      let cardlist = this.cardLists.map(item => {
        if (item.once) {
          item.enableCount = '...'
          item.totalCount = '...'
        }
        return item
      })
      this.cardLists = cardlist

      let orgId = ''

      this.request.post(`/front/device/type/statistics?orgId=${orgId}`).then(res => {
        let { code, data, msg } = res
        if (code == 200) {
          let index = this.cardLists.findIndex(({ typeName }) => typeName == "类型分布")

          this.cardLists[index].enableCount = data.enableCount
          this.cardLists[index].totalCount = data.totalCount

        } else if (code == 500) {
          this.msg.warn(msg);
        }
      })

      this.request.post(`/front/device/registStatistics?orgId=${orgId}`).then(res => {
        let { code, data, msg } = res
        if (code == 200) {
          let index = this.cardLists.findIndex(({ typeName }) => typeName == "注册入库")

          let enableCount = 0
          let totalCount = 0
          data.forEach(item => {
            enableCount += item.registCount
            totalCount += item.totalCount
          });

          this.cardLists[index].enableCount = enableCount
          this.cardLists[index].totalCount = totalCount
        } else if (code == 500) {
          this.msg.warn(msg);
        }
      })

      this.request.post(`/front/device/outboundStatistics?orgId=${orgId}`).then(res => {
        let { code, data, msg } = res
        if (code == 200) {
          let index = this.cardLists.findIndex(({ typeName }) => typeName == "扫码出库")

          let enableCount = 0
          let totalCount = 0
          data.forEach(item => {
            enableCount += item.installCount
            totalCount += item.totalCount
          });

          this.cardLists[index].enableCount = enableCount
          this.cardLists[index].totalCount = totalCount
        } else if (code == 500) {
          this.msg.warn(msg);
        }
      })
    },
    async installEve(row) {
      // console.log(`row`, row)
      this.install.id = row.id
      this.install.show = true
      // const {
      //   data,
      //   msg,
      //   code
      // } = await this.request.post('/front/device/install', row)
      // if (code !== 200) {
      //   return this.$message.error(msg)
      // }
      // this.initData()
      // return this.$message.success(msg)
    },
    removeEveAll () {
      const len = this.checkDatas.length
      if (!len) {
        this.$message({ type: 'warning', message: '请先勾选拆卸设备！' })
      } else {
        this.$confirm('此操作将拆除已选中的设备, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let idsTemp = this.checkDatas.reduce((total, { id }) => {
            return total += `${id},`
          }, '')
          let ids = idsTemp.substr(0, idsTemp.length - 1)
          // console.log(ids)
          this.request.post(`/front/device/unInstall?id=${ids}`).then(rs => {
            if (rs.code === 200) {
              this.initData();
              this.msg.success('操作成功')
            } else {
              this.msg.error(rs.msg)
            }
          })
        }).catch(() => {
          this.msg.info('已取消操作')
        })
      }
    },
    async removeEve(row) {
      // console.log(row);
      // return

      this.$confirm('此操作将拆卸设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.request.post('/front/device/unInstall?id=' + row.id).then(res => {
          if (res.code !== 200) {
            if(res.code==500){
              return this.$message.error(res.msg)
            }
            return
          }
          this.initData()
          return this.$message.success(res.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消拆卸'
        });
      });
    },
    async detailClose(row) {
      // console.log(row);
      // return

      this.$confirm('此操作将删除设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.request.post('/front/device/delDeviceById?id=' + row.id).then(res => {
          if (res.code !== 200) {
            if(res.code==500){
              return this.$message.error(res.msg)
            }
            return
          }
          this.initData()
          return this.$message.success(res.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    async enableEve(row) {
      let par = {
        id: row.id,
        enable: 1
      }
      this.$confirm('此操作将启用该设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.postParamsData('/front/device/enable',par).then(rs => {
          if (rs.code === 200) {
            this.initData();
            this.msg.success('操作成功')
          } else {
            // this.msg.error(rs.msg)
          }
        })
      }).catch(() => {
        this.msg.info('已取消操作')
      });
      // let par = {
      //   id: row.id,
      //   enable: 1
      // }
      // const {
      //   data,
      //   msg,
      //   code
      // } = await this.request.postParamsForm('/front/device/enable', par)
      // if (code !== 200) {
      //   return this.$message.error(msg)
      // }
      // this.initData()
      // return this.$message.success(msg)
    },
    async disableEve(row) {
      let par = {
        id: row.id,
        enable: 0
      }
      this.$confirm('此操作将禁用该设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.postParamsData('/front/device/enable',par).then(rs => {
          if (rs.code === 200) {
            this.initData();
            this.msg.success('操作成功')
          } else {
            // this.msg.error(rs.msg)
          }
        })
      }).catch(() => {
        this.msg.info('已取消操作')
      });
      // let par = {
      //   id: row.id,
      //   enable: 0
      // }
      // const {
      //   data,
      //   msg,
      //   code
      // } = await this.request.postParamsForm('/front/device/enable', par)
      // if (code !== 200) {
      //   return this.$message.error(msg)
      // }
      // this.initData()
      // return this.$message.success(msg)
    },
    async registerEve(row) {
      this.$confirm('此操作将注册, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.request.post('/front/device/regist?id=' + row.id).then(res => {
          if (res.code !== 200) {
            if(res.code==500){
              return this.$message.error(res.msg)
            }
            return
          }
          this.initData()
          return this.$message.success(res.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消注册'
        });
      });
      // const {
      //   data,
      //   msg,
      //   code
      // } = await this.request.postParamsForm('/front/device/regist', row)
      // if (code !== 200) {
      //   return this.$message.error(msg)
      // }
      // this.initData()
      // return this.$message.success(msg)
    },
    async CancelEve(row) {
      this.$confirm('此操作将解除注册, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.request.post('/front/device/unRegist?id=' + row.id).then(res => {
          if (res.code !== 200) {
            if(res.code==500){
              return this.$message.error(res.msg)
            }
            return
          }
          this.initData()
          return this.$message.success(res.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解除注册'
        });
      });
      // const {
      //   data,
      //   msg,
      //   code
      // } = await this.request.postParamsForm('/front/device/unInstall', row)
      // if (code !== 200) {
      //   return this.$message.error(msg)
      // }
      // this.initData()
      // return this.$message.success(msg)
    },
    async installRecord(row) {
      // const {data,code,msg} = await this.request.
      this.installRecordPar.show = true
      this.installRecordPar.id = row.id
    },
    installRecordConfirm() {},
    async installConfirm(par) {
      const {
        res,
        code,
        msg
      } = await this.request.post('/front/device/install', par)
      if (code !== 200) {
        if(code==500){
          return this.$message.error(msg)
        }
        return
      }
      this.initData()
      this.install.show = false
      return this.$message.success(msg)
    },
    // 报修关闭
    handleDrawerClose () {
      this.repairDrawer.show = false
    },
    // 报修打开
    repairClick (row) {
      let { id, imei } = row
      this.repairDrawer.show = true
      this.repairDrawer.form = { deviceId: id, imei, repairDesc: '' }
    },
    // 报修保存
    handleAddSave () {
      this.$refs['repairDrawerForm'].validate((valid) => {
        if (valid) {
          let params = this.repairDrawer.form
          this.repairDrawer.saving = true
          this.request.post('/front/device/repair/add', params).then(res => {
            this.repairDrawer.saving = false
            this.repairDrawer.show = false
            if (res.code === 200) {
              this.$message({ type: 'success', message: `提交成功！`})
              this.pagination.currentPage = 1
              this.initData()
            } else {
              this.$message({ type: 'error', message: `提交失败！请重新提交`})
            }
          })
        } else {
          this.$message({ type: 'warning', message: '请按照要求填写正确信息！'})
          return false;
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.EquipmentWarehousing {
  position: relative;
  height: 100%;
  .topTabs {
    height: 40px;
    background: #fff;
  }

  .cardLists {
    overflow: hidden;
    margin-bottom: 20px;
    // text-align: center;
    padding: 0;

    .card {
      color: #212733;
      display: inline-block;
      width: 14.28%;
      height: 100px;
      box-sizing: border-box;
      padding: 0 10px;

      .cardContent {
        height: 100px;
        border-radius: 10px;
        color: #fff;
        font-size: 14px;
        background-image: linear-gradient(to right, #E16FEB, #8F65F8);

        .header {
          padding: 10px 18px;
          // text-align: left;
          // height: 20px;

          >img {
            width: 16px;
            // height: 16px;
            margin-right: 10px;
          }

          span {
            vertical-align: middle;
            // line-height: 20px;
          }
        }

        .card-number {
          width: calc(100% - 36px);
          height: 58px;
          padding: 0px 18px;
          position: relative;
          p {
            span{
              display: inline-block;
              width: 40px;
              font-size: 12px;
              text-align: right;
              vertical-align: middle;
            }
            span:first-child{
              text-align: left;
              width: calc(100% - 42px);
              font-size: 1.8em;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            &.bottom {
              span{
                // padding-left: 5px;
                font-size: 12px;
              }
              span:first-child{
                // width: calc(100% - 50px);
                font-size: 0.8em;
              }
            }
          }
          img {
            position: absolute;
            top: 5px;
            right: -5px;
            width: 70px;
            opacity: 0.2;
          }
        }
      }

    }
  }
  .mainContent {
    width: 98%;
    height: calc(100% - 140px);
    margin: 0 auto;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    // overflow: auto;
    border-radius: 10px;
    // border: 1px solid red;
    position: relative;


    // .listContainer {
    //   height: 100%;
    //   position: relative;
      // height:calc(100% - 140px);
      .container {
        // border: 1px solid red;
        height: 100%;
        padding: 0 10px 0 300px;
        .btn-repair {
          color: #EEBD78;
        }
        .set-repair {
          display: inline-block;
          width: 14px;
          height: 14px;
          vertical-align: -1px;
          background: url('../../assets/img/back/device/repaire.png');
          margin-right: 5px;
        }
      }
    // }

    .radio {
      font-size: 0;
      margin: 20px 0;

      .noEquipment {
        font-size: 14px;
        font-weight: 400;
        color: #606266;
      }

      .line {
        font-size: 20px;
        font-weight: 100;
        color: #606266;
        margin-right: 25px;
      }
    }

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }

    .detail {
      background: #32AC63;
      color: #fff;
    }

    .btnS {
      color: #fff;
      // border: 1px solid #a1c6f3;
      background: #409EFF;
      margin-right: 0px !important;
      margin-left: 8px;
      float: left;

      &.active {
        // border: 1px solid #F2F2F2;
        background: #F2F2F2;
        color: #AAAAAA;
        cursor: default;
      }
    }
  }
  /deep/.el-dialog__wrapper {
    .el-dialog {
      .el-dialog__body {
        .bangding {
          .el-input {
            width: 41%;
          }
          >span {
            display: inline-block;
            width: 168px;
          }
          .telTitle {
            text-align: right;
            color: red;
            padding-right: 40px;
            margin-top: 10px;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style><style lang="scss">
.EquipmentWarehousing {
  .treeAside {
    position: absolute;
    width: 300px;
    height: 100%;
    padding: 15px 0px 10px 15px;
    left: 0;
    top: 0px;
    box-sizing: border-box;

    .treeTop {
      position: absolute;
      height: 40px;
      line-height: 40px;
      font-size: 0;
      font-weight: bold;
      top: 15px;
      z-index: 10;
      // left: 30px;
      padding-left: 10px;

      .treeTopTitle {
        margin-right: 115px;
        // width: 500px;
        font-size: 18px;
        color: #333;
      }

      .el-button {
        margin-left: -24px;
      }

      .complete {
        margin-left: 10px;
      }
    }

    .treeBox {
      overflow: hidden;
      height: 100%;
      border: 1px solid #ebeef5;
      padding: 40px 0 10px;
      box-sizing: border-box;
    }

    .tree {
      height: 100%;
      overflow: auto;

      .el-tree-node__content {
        height: 40px;
      }

      .custom-tree-node {
        height: 40px;
        line-height: 40px;
        width: 100%;

        .treeLabel {
          font-size: 14px;
          display: inline-block;
          width: 130px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .treeBtn {
          float: right;

          .el-button {
            margin-left: 0;
          }
        }
      }
    }
  }

  .query {
    overflow: hidden;
    .upload-demo {
      display: inline-block;
    }
    .common{
      // float: left;
      margin-bottom: 5px;
      margin: 0px 4px 5px 4px;
    }
    // .common1.el-input{
    //   width: 120px;
    // }

    .el-input {
      width: 160px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-select {
      width: 105px;
      margin-right: 5px;

      .el-input {
        width: 105px;
        margin-right: 5px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
      border-color: #42bced;
      background: #42bced;
    }

    .el-radio.is-checked .el-radio__label {
      color: #147dd9 !important;
    }
    .el-button--medium {
      padding: 10px 10px;
    }
  }

  .add-user-tell-box {
    margin-bottom: 15px;
    .title {
      display: inline-block;
      width: 170px;
    }
    .tel-box {
      display: inline-block;
      width: 260px;
      vertical-align: top;
    }
    .el-input {
      width: 200px;
    }
    .tell {
      display: inline-block;
      margin-top: 10px;
    }
    .icons {
      font-size: 20px;
      margin-left: 10px;
      color: #409EFF;
      &.el-icon-delete {
        color: red;
        cursor: pointer;
      }
    }
  }
}
</style>
